import React from 'react'
import MemberLeft from './member-left'
import MemberRight from './member-right'

const Member = ({leftinfo}) => {
  return (
    <div>
        <div className='member-container'>
            <MemberLeft
            leftinfo={leftinfo}
            />
            <MemberRight leftinfo={leftinfo}/>
        </div>
    </div>
  )
}

export default Member